<template>
    <KeepAlive>
      <MapComp id_map="global_map"/>
    </KeepAlive>
</template>

<script>
import MapComp from '../components/MapCompCluster.vue';

export default {
	name: 'MapView',
	components: {
    MapComp
},
created() {
  /// default map size
  var clientHeight =  window.innerHeight;
  var r = document.querySelector(':root');
  clientHeight = clientHeight - require('../assets/global.json').headerSize+"px"
  r.style.setProperty('--mapHeight', clientHeight);


  //// map height for client, responsive
  window.addEventListener('resize', function() {
      var clientHeight =  window.innerHeight;
      var r = document.querySelector(':root');
      clientHeight = clientHeight - require('../assets/global.json').headerSize+"px"
      r.style.setProperty('--mapHeight', clientHeight);
    }, true);
}

}
</script>


<style>

#global_map {
  height: var(--mapHeight);
}


</style>
